import cc from "classcat";
import { memo } from "react";

import styles from "./RowDragIndicator.module.scss";

/**
 * Drag affordance rendered to the left of a customization row. The parent row
 * is responsible for `position: relative` and for revealing this on hover by
 * setting `--row-drag-indicator-opacity` / `--row-drag-indicator-events`.
 */
const RowDragIndicator = ({ disabled }: { disabled: boolean }) => (
  <div
    className={cc([
      styles["drag-indicator"],
      disabled && styles["drag-indicator--hidden"]
    ])}
  >
    <div className={styles["drag-indicator-spacing"]}>
      <span
        className={cc([styles["drag-indicator-icon"], "narmi-icon-menu"])}
      />
    </div>
  </div>
);

export default memo(RowDragIndicator);
